import { AppBar } from '@horof/shared';
import { createBrowserRouter, Outlet, ScrollRestoration } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { BillPage } from './BillPage';
import { HELP } from './help';
import { ListStateProvider } from './list-state';
import { MemberPage } from './MemberPage';
import { MembersPage } from './MembersPage';
import { TodayPage } from './TodayPage';

function Layout() {
  return (
    <ListStateProvider>
      <ScrollRestoration />
      <AppBar help={HELP} />
      <Outlet />
    </ListStateProvider>
  );
}

const router = createBrowserRouter(
  [
    {
      element: <Layout />,
      children: [
        { path: '/', element: <MembersPage /> },
        { path: '/member/:memberId', element: <MemberPage /> },
        { path: '/today', element: <TodayPage /> },
        { path: '/bill/:billId', element: <BillPage /> },
      ],
    },
  ],
  { basename: import.meta.env.BASE_URL },
);

export function App() {
  return <RouterProvider router={router} />;
}
